<form-field
        [formGroup]="group"
        [options]="fieldConfig">
    <div [formGroup]="group" [attr.class]="styleForm">
        <div [class.has-icon]="icon" class="field">
            <i *ngIf="icon" [attr.class]="icon"></i>
            <p-dropdown [options]="options"
                        [formControlName]="controlName"
                        (onBlur)="onBlur($event)"
                        (onChange)="onChange($event)"
                        [placeholder]="placeholder ? placeholder : ' '"
                        [disabled]="disabled" [appendTo]="appendTo"
                        [focusMe]="focusEmit"
            ></p-dropdown>
            <!-- TODO NG UPGRADE propriété qui n'existe plus
                [autoWidth]="false" -->
        </div>
    </div>
</form-field>
